import { addDays, eachDayOfInterval, endOfMonth, endOfWeek, isWeekend, startOfMonth, startOfWeek } from 'date-fns';
import { Component, component, DateType, property } from '../../../../concepts/objects';
import { Rect } from '../../../../platform/geom/Rect';
import { TransformAction } from '../../../canvas/entities/Physical';
import { Frame } from '../Frame';
import { FrameAddon } from '../FrameAddon';
import { GridLayout, LayoutGroup } from '../Layout';
import { CalendarFrameAddonPropertyLayout } from './CalendarFrameAddonPropertyLayout';

export const CalendarFrameAddonLayout = (object: CalendarFrameAddon) => {
    const { base } = object.parentFrame.layout;

    const start = startOfWeek(startOfMonth(object.from));
    const end = endOfWeek(endOfMonth(object.from));

    const showMonth = object.headers.includes('month');
    const showDays = object.headers.includes('days');
    const showWeekends = object.weekends;

    const top = new Rect(0, 0, base.width, 0);

    const monthValues = [{ date: start }];
    const month = GridLayout.from(
        top.set({ height: showMonth ? 50 : 0 }),
        1,
        monthValues,
    );

    const dayValues = Array.from({ length: 7 })
        .map((_, i) => ({ date: addDays(start, i) }))
        .filter(x => showWeekends || !isWeekend(x.date))
    const days = GridLayout.from(
        month.area.set({ top: month.area.bottom, height: showDays ? 50 : 0 }),
        dayValues.length,
        dayValues
    );

    const bodyValues = eachDayOfInterval({ start, end })
        .map((x, i) => ({ date: x }))
        .filter(x => showWeekends || !isWeekend(x.date));
    const body = GridLayout.from(
        days.area.set({ top: days.area.bottom, height: base.height - days.area.bottom }),
        dayValues.length,
        bodyValues,
    );

    const head = LayoutGroup.from({ month, days });

    return { base, head, body };
};

export type CalendarFrameAddonLayout = ReturnType<typeof CalendarFrameAddonLayout>;

export type CalendarFrameAddonHeaders = ('month' | 'days')[];

const calendarFrameAddonDef = {
    name: 'CalendarFrameAddon',
    implements: [FrameAddon],
    propertyLayout: CalendarFrameAddonPropertyLayout,
};

@component(calendarFrameAddonDef)
export class CalendarFrameAddon extends Component implements FrameAddon {

    public get parentFrame() {
        return this.parent?.as(Frame);
    }

    public get layout() {
        return CalendarFrameAddonLayout(this);
    }

    @property({ type: 'string', default: 'bottom' })
    public layer: 'bottom' | 'top';

    @property({ type: 'string' })
    public color: string;

    @property({ type: DateType })
    public from: Date;

    @property({ type: 'string[]', default: ['month', 'days'] })
    public headers: CalendarFrameAddonHeaders;

    @property({ type: 'boolean', default: true })
    public weekends: boolean;

    public queryTransformActions(singular: boolean): TransformAction[] {
        return [];
    }
}
